export const TABLE_CHART = {
  EPA: 'EPA',
  PLAY_PERCENTAGE: 'PlayPercentage',
  PLAY_PERCENTAGE_SMALL: 'PlayPercentageSmall',
};
